import React, { forwardRef } from 'react';
import { alpha } from '@mui/material/styles';
import { AddOutlined } from '@mui/icons-material';

import PinguComposerChip from './PinguComposerChip';

type PinguIncludePageChipProps = { onInclude: () => void };

// What the page tag leaves behind after × (chips.md 7.27): a dashed chip in
// the outlined-button border of buttons.md 6.5 that puts the page back.
const PinguIncludePageChip = forwardRef<HTMLDivElement, PinguIncludePageChipProps>(({
  onInclude,
}, ref) => (
  <PinguComposerChip
    ref={ref}
    icon={<AddOutlined />}
    label="Include this page"
    onClick={onInclude}
    sx={{
      position: 'relative',
      borderStyle: 'dashed',
      borderColor: (theme) => alpha(theme.palette.emphasisText.main, 0.5),
      color: 'text.secondary',
      fontWeight: 500,
      // Keeps the click area at 24px although the chip is 22px tall.
      '&::after': { content: '""', position: 'absolute', inset: -1 },
      '&.MuiChip-clickable:hover': {
        bgcolor: (theme) => alpha(theme.palette.emphasisText.main, 0.08),
        borderColor: (theme) => alpha(theme.palette.emphasisText.main, 0.6),
      },
    }}
  />
));

PinguIncludePageChip.displayName = 'PinguIncludePageChip';

export default PinguIncludePageChip;
